import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { Page, Pane, PaneBackButton, PaneHeader } from '../../components/atoms/applications/page';
import './reservationAttendancePage.module.scss';
import { LoaderRow } from '../../components/atoms/layout/LoaderRow';
import { authenticated } from '../../components/hocs/authenticated';
import { ReservationAttendanceCompletePageState } from './states/ReservationAttendanceCompletePageState';
import { ReservationId } from '../../../commonv3/types/reservations';
import { ReservationCard } from '../../components/molecules/reservations/ReservationCard';

export type Props = {
    match: {
        params: {
            reservationId: ReservationId;
        };
    };
};

@authenticated
@observer
export class ReservationAttendanceCompletePage extends React.Component<Props> {
    pageState = new ReservationAttendanceCompletePageState();

    async componentWillMount() {
        const { reservationId } = this.props.match.params;
        await this.pageState.init(reservationId);
    }

    render() {
        const { loading, reservation } = this.pageState;
        const index = 1;
        return (
            <Page>
                {loading ? (
                    <LoaderRow />
                ) : (
                    <div>
                        <div styleName="body">
                            <div styleName="header">
                                <div styleName="title">出席完了</div>
                                <div styleName="text">スタッフにこちらの画面をみせてください</div>
                            </div>
                            <ReservationCard
                                reservation={reservation.get()}
                                index={index}
                                showButton={false}
                                onRequestUpdate={() => {}}
                            />
                        </div>
                    </div>
                )}
            </Page>
        );
    }
}
